<template>
  <svg xmlns="http://www.w3.org/2000/svg" class="icon" viewBox="0 0 24 24">
    <path
      d="M3 7.25418V4.72575C3 3.77258 3.77258 3 4.72575 3H19.2742C20.2274 3 21 3.77258 21 4.72575V19.2742C21 20.2274 20.2274 21 19.2742 21H4.72575C3.77258 21 3 20.2274 3 19.2742V16.7458"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
      fill="none"
    />
    <path
      d="M13.1914 15.8274L17.0075 12"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
      fill="none"
    />
    <path
      d="M17.0075 11.9999L13.1914 8.18384"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
      fill="none"
    />
    <path
      d="M17.0075 12H3"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
      fill="none"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconLogoutSquare',
};
</script>

<style scoped>
.icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  fill: inherit;
  flex-shrink: 0;
}
</style>
